const jQuery = require("jquery");
import { PhonePrefix } from './PhonePrefix'

jQuery(document).ready(($) => {

    //let postalField;
    var GoogleMaps = {

        getFields: function() {
            return ['street', 'number', 'city', 'zip', 'state', 'nation'];
        },
        showFields: function(ids, status) {
            this.getFields().forEach(name => {
                let element = $(ids[name]).closest('.cell');

                return status ? element.removeClass('hide') : element.addClass('hide');
            })
        },
        isOneFieldEmpty: function(ids) {
            return this.getFields().filter(name => {
                return $(ids[name]).val() == "";
            }).length > 0;
        },
        showFieldsWhenEmpty: function(ids, status) {
            this.showFields(ids, this.isOneFieldEmpty(ids));
        },
        initPhone: function (name, ids) {
            if (ids.phone.length) {
                new PhonePrefix($(ids.phone)).init();
            }
        },
        validateAddress: function (element, status) {
          console.log(status)
        },
        initAutocomplete: function(name, ids) {

            this.initPhone(name, ids);

            ids.on && ids.on($(ids.nation).val());

            const container = document.createElement("div");

            var autocomplete;
            let address1Field;
            let firstInput = $(ids.address).attr('value') == "";
            if (firstInput) {
                this.showFields(ids, false)
            }

            address1Field = document.querySelector(ids.address);

            autocomplete = new google.maps.places.Autocomplete(address1Field, {
                fields: ["address_components", "geometry"],
                types: ["address"],
            });

            autocomplete.addListener("place_changed",() => {
                GoogleMaps.fillInAddress(ids, autocomplete, firstInput)
                address1Field.setCustomValidity("");
            });

            address1Field.addEventListener("change",() => {
                // Force for every change the invalidation, it will be reset if the user pick the place
                address1Field.setCustomValidity("Invalid Address");
            });


            if (!ids.disablePac) {
                setTimeout(function () {

                    let pac = GoogleMaps.getAutocompletePacContainer(autocomplete);
                    pac.attr("data-name", name)

                }, 1000)
            }

        },
        getAutocompletePacContainer: function(autocomplete) {
            var obj = autocomplete.gm_accessors_.place;

            $.each(Object.keys(obj), function(i, key) {
                if(typeof(obj[key]) == "object" && obj[key].hasOwnProperty("gm_accessors_")) {
                    obj = obj[key].gm_accessors_.input[key];
                    return false;
                }
            });
            $.each(Object.keys(obj), function(i, key) {
                try {
                    if ($(obj[key]).hasClass("pac-container")) {
                        obj = obj[key];
                        return false;
                    }
                } catch (e) {
                    console.log("Ignoring, address is not valid in english")
                }
            });

            return $(obj);
        },
        toggle: (target, status) => {

            if (!target) {
                return;
            }

            if (status) {
                target.attr('required', '')
                //target.parent().show();
            } else {
                target.removeAttr('required')
                // target.val('');
                //target.parent().hide();
            }
            target.change();
        },

        fillInAddress: function(ids, autocomplete, firstInput) {


            const place = autocomplete.getPlace();

            if (!place.geometry) {
                console.log('You entered: ' + place.name);
                return;
            }

            console.log(place.geometry)

            let address1 = "";
            let postcode = "";

            $("#lat").val(place.geometry.location.lat());
            $("#lng").val(place.geometry.location.lng());

            $(ids.zip).val("");
            $(ids.city).val("");
            $(ids.nation).val("");
            $(ids.state).val("");
            $(ids.number).val("");
            $(ids.street).val("");


            // Get each component of the address from the place details,
            // and then fill-in the corresponding field on the form.
            // place.address_components are google.maps.GeocoderAddressComponent objects
            // which are documented at http://goo.gle/3l5i5Mr
            for (const component of place.address_components) {
                // @ts-ignore remove once typings fixed
                const componentType = component.types[0];

                switch (componentType) {
                    case "street_number": {
                        address1 = `${component.long_name} ${address1}`;
                        $(ids.number).val(component.long_name);
                        $(ids.number).change();

                        break;
                    }

                    case "route": {
                        address1 += component.short_name;

                        $(ids.street).val(component.long_name);
                        $(ids.street).change();

                        break;
                    }

                    case "postal_code": {
                        postcode = `${component.long_name}${postcode}`;
                        $(ids.zip).val(postcode);
                        $(ids.zip).change();

                        break;
                    }

                    case "postal_code_suffix": {
                        postcode = `${postcode}-${component.long_name}`;
                        break;
                    }
                    case "locality":
                        $(ids.city).val(component.long_name);
                        $(ids.city).change();

                        break;
                    case "administrative_area_level_1": {
                        // document.querySelector("#autocomplete_state").value = component.short_name;
                        // $('#autocomplete_state_field').val(component.short_name);

                        break;
                    }
                    case "administrative_area_level_2": {
                        $(ids.state).val(component.short_name);
                        $(ids.state).change()
                        break;
                    }

                    case "administrative_area_level_3": {
                        if (!$(ids.state).val()) {
                            $(ids.state).val(component.short_name);
                            $(ids.state).change();
                        }
                        break;
                    }
                    case "country":
                        $(ids.nation).val(component.long_name);
                        $(ids.nation).change();
                        //component.short_name != 'IT' && $(ids.state).val('EE');

                        ids.on && ids.on(component.long_name);
                        break;
                }
            }


            let params = ['state', 'city', 'nation'];

            params.forEach((name) => {
                let target = $(ids[name]);
                if (target.val() == "") {
                    target.removeAttr("readonly")
                } else {
                    target.attr("readonly", "readonly")
                }
            })

            // Only when one field is empty and it's the first-time, show them, otherwise remain hidden
            if (firstInput) {
                this.showFieldsWhenEmpty(ids, true)
            }


        }
    }


    if (document.getElementById("user[address]") != null) {
        GoogleMaps.initAutocomplete("user", {
            address: "#user\\[address\\]",
            street: "#user\\[street\\]",
            number: "#user\\[number\\]",
            city: "#user\\[city\\]",
            zip: "#user\\[zip\\]",
            state: "#user\\[province_state\\]",
            nation: "#user\\[nation\\]",
            phone: "#user\\[phone\\]",
        });
    }

    if (document.getElementById("company_billing_address[address]") != null) {
        GoogleMaps.initAutocomplete("company", {
            address: "#company_billing_address\\[address\\]",
            street: "#company_billing_address\\[street\\]",
            number: "#company_billing_address\\[number\\]",
            city: "#company_billing_address\\[city\\]",
            zip: "#company_billing_address\\[zip\\]",
            state: "#company_billing_address\\[province_state\\]",
            nation: "#company_billing_address\\[nation\\]",
            phone: "#company_billing_address\\[phone\\]",
            on: (country) => {

                if (!country) {
                    return null;
                }

                GoogleMaps.toggle($("#company\\[billing_cdi\\]"), country == 'Italy')
                GoogleMaps.toggle($("#company\\[billing_vat\\]"), APP_CFG.cee.indexOf(country) !== -1)
            }
        });
    }

    if (document.getElementById("user_address") != null) {
        GoogleMaps.initAutocomplete("not_user_billing_test", {
            address: "#user_address",
            street: "#user_street",
            number: "#user_number",
            city: "#user_city",
            zip: "#user_zip",
            state: "#user_province_state",
            nation: "#user_nation",
            phone: "#user_phone",
        });
    }

    if (document.getElementById("company_billing_address") != null) {
        GoogleMaps.initAutocomplete("company_billing", {
            address: "#company_billing_address",
            street: "#company_billing_street",
            number: "#company_billing_number",
            city: "#company_billing_city",
            zip: "#company_billing_zip",
            state: "#company_billing_province_state",
            nation: "#company_billing_nation",
            phone: "#company_billing_phone",
            on: (country) => {

                if (!country) {
                    return null;
                }

                GoogleMaps.toggle($("#company_billing_cdi"), country == 'Italy')
                GoogleMaps.toggle($("#company_billing_vat"), APP_CFG.cee.indexOf(country) !== -1)
            }
        });
    }

    window.GoogleMaps = GoogleMaps;

});